import React, { useState, ChangeEvent, FormEvent } from 'react';
import { SimulationData } from '../App';

interface IntakeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onStartSimulation: (data: SimulationData) => void;
}

interface LeadFormData {
  country: string;
  city: string;
  email: string;
  company: string;
  industry: string;
  [key: string]: string | number | undefined;
}

const IntakeModal: React.FC<IntakeModalProps> = ({ isOpen, onClose, onStartSimulation }) => {
  const [formData, setFormData] = useState<LeadFormData>({ country: '', city: '', email: '', company: '', industry: '' });

  if (!isOpen) return null;

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    onClose();
    onStartSimulation(formData);
  };

  return (
    <div className="login-overlay" onClick={onClose}>
      <div className="intake-modal" onClick={(e) => e.stopPropagation()}>
        <div className="intake-modal-header">
          <h2>Start Your Free Simulation</h2>
          <p>Tell us about your target market and we'll deliver your simulation within 72 hours.</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="intake-modal-body">
            <div className="login-group">
              <label>Target Country *</label>
              <select name="country" value={formData.country} onChange={handleChange} required>
                <option value="">Select a Country</option>
                <option value="United States">United States</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="Germany">Germany</option>
                <option value="France">France</option>
                <option value="Netherlands">Netherlands</option>
                <option value="Spain">Spain</option>
                <option value="Italy">Italy</option>
                <option value="Canada">Canada</option>
                <option value="Australia">Australia</option>
                <option value="Japan">Japan</option>
              </select>
            </div>
            <div className="login-group">
              <label>Target City *</label>
              <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="e.g., New York" required />
            </div>
            <div className="login-group">
              <label>Your Work Email *</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="e.g., you@company.com" required />
            </div>
            <div className="login-group">
              <label>Company Name *</label>
              <input type="text" name="company" value={formData.company} onChange={handleChange} placeholder="Your company" required />
            </div>
            <div className="login-group">
              <label>Industry</label>
              <input type="text" name="industry" value={formData.industry} onChange={handleChange} placeholder="e.g., SaaS, E-commerce" />
            </div>
          </div>
          <div className="intake-modal-footer">
            <button type="button" className="login-google" onClick={onClose}>Cancel</button>
            <button type="submit" className="login-submit">Start My Simulation →</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IntakeModal;
